import { captureMessage } from '@sentry/react';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { IS_NATIVE } from 'gcs-common/constants/deviceConstants';

enum CapacitorSecureStorageKeys {
  refresh_token = 'refresh_token',
}

class CapacitorSecureStorageService {
  async getSessionRefreshToken() {
    const { value } = await this.get({ key: CapacitorSecureStorageKeys.refresh_token });
    return value;
  }

  async setSessionRefreshToken(refreshToken: string): Promise<void> {
    try {
      await this.set({
        key: CapacitorSecureStorageKeys.refresh_token,
        value: refreshToken,
      });
    } catch (error) {
      captureMessage('storing refresh token failed', {
        extra: { error },
      });
      console.error('storing refresh token failed', error);
    }
  }

  async removeSessionRefreshToken(): Promise<void> {
    try {
      await this.remove({ key: CapacitorSecureStorageKeys.refresh_token });
    } catch (error) {
      captureMessage('removing refresh token failed', {
        extra: { error },
      });
      console.error('removing refresh token failed', error);
    }
  }

  async get(options: { key: string }): Promise<{ value: string }> {
    this.checkNative();
    return SecureStoragePlugin.get(options);
  }

  async set(options: { key: string; value: string }): Promise<{ value: boolean }> {
    this.checkNative();
    return SecureStoragePlugin.set(options);
  }

  async remove(options: { key: string }): Promise<{ value: boolean }> {
    this.checkNative();
    return SecureStoragePlugin.remove(options);
  }

  private checkNative() {
    if (!IS_NATIVE) {
      throw new Error('Secure storage is only available on native platforms.');
    }
  }
}

export const capacitorSecureStorageService = new CapacitorSecureStorageService();
